import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';

/**
 * Calculate the number of nights between checkIn and checkOut.
 *
 * Uses `differenceInCalendarDays` which is timezone-safe — it compares
 * dates at midnight of each local day, ignoring DST and timezone offsets.
 *
 * Returns `null` for:
 * - Missing or empty date strings
 * - Invalid date strings (cannot be parsed by `parseISO`)
 * - Same-day or negative range (checkOut <= checkIn)
 */
export function calculateNights(
  checkIn: string | null | undefined,
  checkOut: string | null | undefined,
): number | null {
  if (!checkIn || !checkOut) return null;

  const inDate = parseISO(checkIn);
  const outDate = parseISO(checkOut);

  if (!isValid(inDate) || !isValid(outDate)) return null;

  const nights = differenceInCalendarDays(outDate, inDate);

  return nights > 0 ? nights : null;
}
